import { render, staticRenderFns } from "./GLCustomerUploadPosting.vue?vue&type=template&id=f07e6b8c&"
import script from "./GLCustomerUploadPosting.vue?vue&type=script&lang=js&"
export * from "./GLCustomerUploadPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports